export const INACTIVE_USER_TIME_THRESHOLD = 480000; /*TIEMPO DE INACTIVIDAD => 8 min. (mls)*/
export const USER_ACTIVITY_THROTTLER_TIME = 3600000; /*TIEMPO DE SESIÓN => 1 hr. (mls)*/